import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export const ProtectedRoute = ({ children, requireOrganizer = false, requireAdmin = false, requireStaff = false }) => {
    const { isAuthenticated, isOrganizer, isAdmin, isStaff, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
                <div className="animate-pulse-soft text-muted-foreground font-medium">Loading...</div>
            </div>
        );
    }
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    if (requireAdmin && !isAdmin) {
        return <Navigate to="/" replace />;
    }
    if (requireOrganizer && !isOrganizer) {
        return <Navigate to="/become-organizer" replace />;
    }
    if (requireStaff && !isStaff) {
        return <Navigate to="/" replace />;
    }
    return children;
};
